import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import CenterContentLayout from '../../../components/layout/CenterContentLayout';
import classes from '../Error.module.css';

const ServerError = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>LifeCloud | בית חדש לחיים שאחרי</title>
        <meta property="og:url" content="https://lifecloud-qr.com/505" />
      </Helmet>
      <CenterContentLayout bg="#DCECF4">
        <div className={`container text-center ${classes.error_container}`}>
          <h1>505</h1>
          <h3>קרתה תקלה :( עובדים על פיתרון</h3>
          <Link to="/">חזרה</Link>
        </div>
      </CenterContentLayout>
    </React.Fragment>
  );
};

export default ServerError;
